export default "__VITE_ASSET__CvqEcqQz__"